var codeTables = [
    'code_model',
    'code_condition',
    'code_late_notification_type',
    'code_message_interval',
    'code_route_type',
    'code_rule',
    'code_student_contact_type',
    'code_time_of_day',
    'code_file_upload_type',
];

(function () {
    angular.module('app.ocom')
        .config(function (ngDexieProvider) {
            ngDexieProvider.setOptions({name: 'api', debug: false});
            ngDexieProvider.setConfiguration(function (db) {

                var codeTableDef = "++id,active_start_date,active_end_date,description";

                var stores = {
                    'ocom_model': '++id',
                    'active_model': '++id',
                    'user_profile': '++id',
                    'notification_sent': '++id',
                    'route': '++id',
                    'route_staff': '++id',
                    'route_stop': '++id',
                    'school': '++id',
                    'file_upload': '++id',
                    'student': '++id',
                    'student_absence': '++id',
                    'student_contact': '++id',
                    'student_seat_allocation': '++id',
                    'student_trip': '++id',
                    'student_trip_history': '++id',
                    'student_incident_report': '++id',
                    'incident_report': '++id',
                    'unexpected_traveller': '++id',
                    'base_trip': '++id',
                    'base_trip_history': '++id',
                    'base_imported_item': '++id',
                    'imported_school': '++id',
                    'imported_company': '++id',
                    'imported_route': '++id',
                    'imported_student': '++id',
                    'imported_student_trip': '++id',
                    'case_file_upload': '++id',

                    'synclog': "++id,when"
                };

                _.each(codeTables, function (codeTableName) {
                    stores[codeTableName] = codeTableDef;
                });

                db.version(1).stores(stores);

                db.on('error', function (err) {
                    // Catch all uncatched DB-related errors and exceptions
                    console.error("db error err=" + err);
                });
            });
        });

})();
